const ASSET_RECOVERY_KEY = 'front-v2:asset-recovery';
const ASSET_RECOVERY_COOLDOWN_MS = 30_000;

function errorMessage(error: unknown) {
  if (error instanceof Error) return `${error.name}: ${error.message}`;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error) return String((error as { message?: unknown }).message || '');
  return '';
}

export function isAssetLoadError(error: unknown) {
  const message = errorMessage(error);
  return /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(message);
}

export function clearAssetRecoveryMarker() {
  try {
    window.sessionStorage.removeItem(ASSET_RECOVERY_KEY);
  } catch {
    // Storage is optional; successful module loading is enough to continue.
  }
}

export function recoverFromAssetLoadError(error: unknown) {
  if (!isAssetLoadError(error)) return false;
  const now = Date.now();
  const path = window.location.href;
  try {
    const raw = window.sessionStorage.getItem(ASSET_RECOVERY_KEY);
    const previous = raw ? JSON.parse(raw) as { path?: string; time?: number } : null;
    if (previous?.path === path && now - Number(previous.time || 0) < ASSET_RECOVERY_COOLDOWN_MS) return false;
    window.sessionStorage.setItem(ASSET_RECOVERY_KEY, JSON.stringify({ path, time: now }));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

export function installAssetLoadRecovery() {
  const onPreloadError = (event: Event) => {
    const payload = (event as Event & { payload?: unknown }).payload;
    if (recoverFromAssetLoadError(payload)) event.preventDefault();
  };
  const onUnhandledRejection = (event: PromiseRejectionEvent) => {
    if (recoverFromAssetLoadError(event.reason)) event.preventDefault();
  };
  const onWindowError = (event: ErrorEvent) => {
    recoverFromAssetLoadError(event.error || event.message);
  };
  window.addEventListener('vite:preloadError', onPreloadError);
  window.addEventListener('unhandledrejection', onUnhandledRejection);
  window.addEventListener('error', onWindowError);
}
